import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { Input } from 'components';

import useValidation from 'hooks/forms/useValidation';

import { publicUrls } from 'constants/urls';

import { ICredentialsStepProps } from './CredentialsStep.types';

const CredentialsStep = ({ loading }: ICredentialsStepProps) => {
  const { t } = useTranslation();
  const rule = useValidation();

  return (
    <>
      <Form.Item name="email" label={t('form.label.email')} rules={[rule.required, rule.email]} validateFirst>
        <Input autoFocus disabled={loading} />
      </Form.Item>

      <Form.Item
        name="password"
        label={t('form.label.password')}
        rules={[rule.required]}
        validateFirst
        className="np-login-form__password-form-item"
      >
        <div className="np-login-form__forgot-container">
          <Input.Password disabled={loading} />
          <NavLink tabIndex={-1} to={publicUrls.forgotPassword} className="np-login-form__forgot-link">
            {t('page.login.link.forgotPassword')}
          </NavLink>
        </div>
      </Form.Item>
    </>
  );
};

export default CredentialsStep;
